/*
 * collection-filters.js — miglioramento progressivo per i facet nativi.
 * Aggiorna la griglia via fetch (senza reload) al cambio di filtri/ordinamento
 * e sui link di paginazione. Senza JS il form fa un normale submit GET.
 */
(function () {
  var form = document.querySelector('[data-facets-form]');
  var grid = document.getElementById('CollectionProductGrid');
  if (!form || !grid) return;

  var anchor = form.closest('.container') || grid;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var controller = null;
  var priceTimer = null;

  function hideApply() {
    form.querySelectorAll('.facets__apply').forEach(function (b) { b.style.display = 'none'; });
  }
  hideApply();

  function buildUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (val, key) {
      if (val !== '' && val != null) params.append(key, val);
    });
    var qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function navigate(url, push) {
    grid.classList.add('is-loading');
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(url, { signal: controller.signal, headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('CollectionProductGrid');
        if (!newGrid) throw new Error('no-grid');
        var newForm = doc.querySelector('[data-facets-form]');
        grid.innerHTML = newGrid.innerHTML;
        if (newForm) { form.innerHTML = newForm.innerHTML; hideApply(); }
        var count = document.querySelector('[data-results-count]');
        var newCount = doc.querySelector('[data-results-count]');
        if (count && newCount) count.innerHTML = newCount.innerHTML;
        grid.classList.remove('is-loading');
        if (push !== false) history.pushState({ facets: true }, '', url);
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url; // fallback robusto (errore HTTP, parsing, offline)
      });
  }

  // Cambio di chip (checkbox) o ordinamento (select) → aggiorna subito.
  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="number"]')) return; // gestito su input+debounce
    navigate(buildUrl());
  });

  // Prezzo: debounce mentre si digita.
  form.addEventListener('input', function (e) {
    if (!e.target.matches('input[type="number"]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () { navigate(buildUrl()); }, 600);
  });

  // Submit (invio da tastiera / no-JS button) → AJAX.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(priceTimer);
    navigate(buildUrl());
  });

  // Link "rimuovi filtro" / "cancella" (nel form) e paginazione (nella griglia).
  // Nella griglia NON intercettare le card prodotto: solo i link di paginazione.
  document.addEventListener('click', function (e) {
    // Rispetta apri-in-nuova-scheda (ctrl/cmd/shift/alt click, tasto non primario, target _blank).
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a');
    if (!a || a.target === '_blank') return;
    var inForm = form.contains(a);
    var inGrid = grid.contains(a);
    if (!inForm && !inGrid) return;
    if (inGrid && a.classList.contains('card')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    e.preventDefault();
    navigate(href);
  });

  window.addEventListener('popstate', function () {
    navigate(window.location.href, false);
  });
})();
